

const SendIcon = () => {
    return (
        <svg width="17px" height="21px" viewBox="0 0 17 21" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <g id="PP---Desktop---Chat-History---1920" transform="translate(-1784, -1136)" stroke="#FFFFFF" strokeWidth="2.5">
                    <g id="Group-12" transform="translate(1775.5, 1129.5)">
                        <g id="Group-5" transform="translate(10.5, 8.5)">
                            <line x1="6.6953" y1="16.8844" x2="6.6953" y2="0.0004" id="Stroke-1"></line>
                            <polyline id="Stroke-3" points="12.782 6.087 6.695 0 0 6.087"></polyline>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default SendIcon;
